import { WifiOff } from "lucide-react"
import { useOnlineStatus } from "@/hooks/use-online-status"
import { translate } from "@/lib/i18n/translate"
import { cn } from "@/lib/utils"

export function OfflineBanner() {
  const { isOnline, lastOnlineAt, showBackOnline } = useOnlineStatus()

  if (isOnline && !showBackOnline) return null

  const timeLabel = lastOnlineAt
    ? lastOnlineAt.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
    : ""

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-[60] px-4 py-2 text-sm text-center",
        showBackOnline
          ? "bg-emerald-600 text-white"
          : "bg-amber-600 text-white"
      )}
      role="status"
    >
      <div className="flex items-center justify-center gap-2">
        {!showBackOnline && <WifiOff className="h-4 w-4 shrink-0" aria-hidden />}
        <span>
          {showBackOnline
            ? translate("pwa.backOnline")
            : translate("pwa.offlineMessage", { time: timeLabel })}
        </span>
      </div>
    </div>
  )
}
